import { OtpVerificationModelDto,OtpVerificationResponseDto } from '@proxy/notifications/models'
export interface OTP extends OtpVerificationModelDto {

}
export interface OTPVerificationResponse extends OtpVerificationResponseDto {

}

